import React, { Fragment } from "react";
import Navbar3 from "../../components/Navbar3/Navbar3";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Industries from "../../components/Industries/Industries";
import Cornerstone from "../../components/Cornerstone/Cornerstone";
import Corevalues from "../../components/Corevalues/Corevalues";
import DirectingOurShip from "../../components/DirectingOurShip/DirectingOurShip";

const AboutPage = () => {
  return (
    <Fragment>
      <div
        style={{
          backgroundImage: `url('/img/aboutbg.jpeg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          position: "relative",
        }}
      >
        <Navbar3 topbarNone={"wpo-header-style-6"} />
        <PageTitle
          pageTitle={"Facilitating Business Excellence via Innovation"}
          pageSub={"Your Reliable Partner for Business Consulting Solutions"}
          backgroundImage={require("../../images/page-title-1.jpeg")}
        />
        <DirectingOurShip />
        <Corevalues />
        <Cornerstone />
        <Industries />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default AboutPage;
